import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/logo.png" alt="Latent Energy" className="footer-logo-img" />
          </div>

          <p className="footer-text">
            Redefining Plastic Recycling through disruptive technology that transforms unsorted plastic waste into high-value circular-carbon commodities.
          </p>

          <div className="footer-links">
            <a href="#overview">Overview</a>
            <a href="#technology">Technology</a>
            <a href="#impact">Impact</a>
            <a href="#team">Team</a>
            <a href="#contact">Contact</a>
          </div>

          <p className="footer-copyright">
            © {new Date().getFullYear()} Latent Energy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
